import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Output, Input, ViewChild, NgModule } from '@angular/core';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import { of, Subject } from 'rxjs';
import { takeUntil, map as map$1 } from 'rxjs/operators';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import { HttpResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import * as i2$1 from 'ngx-toastr';
import * as i3$1 from '@ngrx/store';
import * as i3 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i5$1 from '@progress/kendo-angular-editor';
import { EditorModule } from '@progress/kendo-angular-editor';
import * as i6$1 from '@progress/kendo-angular-toolbar';
import * as i1$2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@progress/kendo-angular-dialog';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import * as i1$1 from '@progress/kendo-angular-upload';
import { UploadModule } from '@progress/kendo-angular-upload';
import * as i5 from '@progress/kendo-angular-inputs';
import { InputsModule } from '@progress/kendo-angular-inputs';
import * as i6 from '@progress/kendo-angular-buttons';

class APIEditor {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    postEditorData(visatype, caseId, payload) {
        return this.httpClient.post(`/${visatype}/PETITION/${caseId}/additionalInfo`, payload).pipe(map((response) => {
            return response;
        }));
    }
    getData(visatype, caseId, infoType) {
        return this.httpClient.get(`/${visatype}/PETITION/${caseId}/additionalInfo/${infoType}`).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
}
APIEditor.ɵfac = function APIEditor_Factory(t) { return new (t || APIEditor)(i0.ɵɵinject(i1.HttpClient)); };
APIEditor.ɵprov = i0.ɵɵdefineInjectable({ token: APIEditor, factory: APIEditor.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIEditor, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class UploadImageComponent {
    constructor() {
        this.uploadSaveUrl = 'api/v1saveUrl'; // Has to represent an actual API endpoint.
        this.uploadRemoveUrl = 'api/v1saveUrl'; // Has to represent an actual API endpoint.
        this.valueChange = new EventEmitter();
    }
    ngOnInit() {
    }
    onSelect(ev) {
        ev.files.forEach((file) => {
            if (file.rawFile) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const img = new Image();
                    img.src = reader.result;
                    img.onload = () => {
                        this.valueChange.emit({
                            src: img.src,
                            height: img.height,
                            width: img.width
                        });
                    };
                };
                reader.readAsDataURL(file.rawFile);
            }
        });
    }
    onRemove() {
        this.valueChange.emit(null);
    }
}
UploadImageComponent.ɵfac = function UploadImageComponent_Factory(t) { return new (t || UploadImageComponent)(); };
UploadImageComponent.ɵcmp = i0.ɵɵdefineComponent({ type: UploadImageComponent, selectors: [["app-upload-image"]], outputs: { valueChange: "valueChange" }, decls: 2, vars: 3, consts: [[3, "saveUrl", "removeUrl", "multiple", "select", "remove"], ["select", "Select image"]], template: function UploadImageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "kendo-upload", 0);
        i0.ɵɵlistener("select", function UploadImageComponent_Template_kendo_upload_select_0_listener($event) { return ctx.onSelect($event); })("remove", function UploadImageComponent_Template_kendo_upload_remove_0_listener() { return ctx.onRemove(); });
        i0.ɵɵelement(1, "kendo-upload-messages", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("saveUrl", ctx.uploadSaveUrl)("removeUrl", ctx.uploadRemoveUrl)("multiple", false);
    } }, directives: [i1$1.UploadComponent, i1$1.CustomMessagesComponent], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UploadImageComponent, [{
        type: Component,
        args: [{
                selector: 'app-upload-image',
                templateUrl: './upload-image.component.html',
                styleUrls: ['./upload-image.component.scss']
            }]
    }], function () { return []; }, { valueChange: [{
            type: Output
        }] }); })();

function UploadImageDialogComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "kendo-dialog", 1);
    i0.ɵɵlistener("close", function UploadImageDialogComponent_ng_container_0_Template_kendo_dialog_close_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.close(); });
    i0.ɵɵelementStart(2, "div", 2);
    i0.ɵɵelementStart(3, "div", 3);
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵelementStart(5, "div", 5);
    i0.ɵɵelementStart(6, "form", 6);
    i0.ɵɵelementStart(7, "div", 7);
    i0.ɵɵelementStart(8, "label");
    i0.ɵɵtext(9, "Image");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "app-upload-image", 8);
    i0.ɵɵlistener("valueChange", function UploadImageDialogComponent_ng_container_0_Template_app_upload_image_valueChange_10_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.setUploadImageInfo($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 7);
    i0.ɵɵelementStart(12, "label", 9);
    i0.ɵɵtext(13, "Height (px)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "kendo-numerictextbox", 10, 11);
    i0.ɵɵlistener("valueChange", function UploadImageDialogComponent_ng_container_0_Template_kendo_numerictextbox_valueChange_14_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.height = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 7);
    i0.ɵɵelementStart(17, "label", 9);
    i0.ɵɵtext(18, "Width (px)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "kendo-numerictextbox", 10, 12);
    i0.ɵɵlistener("valueChange", function UploadImageDialogComponent_ng_container_0_Template_kendo_numerictextbox_valueChange_19_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.width = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "kendo-dialog-actions");
    i0.ɵɵelementStart(22, "button", 13);
    i0.ɵɵlistener("click", function UploadImageDialogComponent_ng_container_0_Template_button_click_22_listener() { i0.ɵɵrestoreView(_r4); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.close(); });
    i0.ɵɵtext(23, "Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "button", 14);
    i0.ɵɵlistener("click", function UploadImageDialogComponent_ng_container_0_Template_button_click_24_listener() { i0.ɵɵrestoreView(_r4); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.uploadImage(); });
    i0.ɵɵtext(25, "Insert");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r1 = i0.ɵɵreference(15);
    const _r2 = i0.ɵɵreference(20);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("minWidth", 250)("width", 450);
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("for", _r1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r0.height)("min", 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("for", _r2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r0.width)("min", 0);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("disabled", ctx_r0.canInsert);
} }
class UploadImageDialogComponent {
    constructor() {
        this.opened = false;
    }
    get canInsert() {
        return !this.src;
    }
    uploadImage() {
        // Invoking the insertImage command of the Editor.
        this.editor.exec('insertImage', this.UploadImageInfo);
        // Closing the Dialog.
        this.close();
    }
    get UploadImageInfo() {
        return {
            src: this.src,
            height: this.height,
            width: this.width
        };
    }
    setUploadImageInfo(value) {
        if (value) {
            this.src = value.src;
            this.height = value.height;
            this.width = value.width;
        }
        else {
            this.resetData();
        }
    }
    open() {
        this.opened = true;
    }
    close() {
        this.opened = false;
        this.resetData();
    }
    resetData() {
        this.src = null;
        this.width = null;
        this.height = null;
    }
    /*
        Mocked backend service.
        For further details, check
        https://angular.io/guide/http#writing-an-interceptor
   */
    intercept(req, next) {
        //if(req.url.indexOf("api/v1saveUrl") != -1){
        if ((req.url.indexOf("api/v1saveUrl") != -1) || (req.url.indexOf("saveUrl") != -1)) {
            //return of(new HttpResponse({ status: 200 }));
            return of(new HttpResponse({ status: 200, body: " " }));
        }
        return next.handle(req);
    }
}
UploadImageDialogComponent.ɵfac = function UploadImageDialogComponent_Factory(t) { return new (t || UploadImageDialogComponent)(); };
UploadImageDialogComponent.ɵcmp = i0.ɵɵdefineComponent({ type: UploadImageDialogComponent, selectors: [["app-upload-image-dialog"]], inputs: { editor: "editor" }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["title", "Upload Image", 3, "minWidth", "width", "close"], [1, "row", "example-wrapper"], [1, "col-xs-8", "col-sm-12", "example-col"], [1, "card"], [1, "card-block"], [1, "k-form-inline"], [1, "k-form-field"], [3, "valueChange"], [3, "for"], ["format", "n0", 3, "value", "min", "valueChange"], ["heightInput", ""], ["widthInput", ""], ["kendoButton", "", 1, "k-button", "k-button-md", "k-rounded-md", "k-button-rectangle", "k-button-solid-base", "k-button-solid", "ng-star-inserted", 3, "click"], ["kendoButton", "", "ng-reflect-primary", "true", "themeColor", "primary", 1, "k-button", "k-button-md", "k-rounded-md", "k-button-rectangle", "k-button-solid-primary", "k-button-solid", "ng-star-inserted", 3, "disabled", "click"]], template: function UploadImageDialogComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, UploadImageDialogComponent_ng_container_0_Template, 26, 9, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.opened);
    } }, directives: [i1$2.NgIf, i2.DialogComponent, i3.ɵangular_packages_forms_forms_ba, i3.NgControlStatusGroup, i3.NgForm, UploadImageComponent, i5.NumericTextBoxComponent, i2.DialogActionsComponent, i6.Button], styles: ["my-upload[_ngcontent-%COMP%]{min-width:175px;max-width:275px}label[_ngcontent-%COMP%]{width:100px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UploadImageDialogComponent, [{
        type: Component,
        args: [{
                selector: 'app-upload-image-dialog',
                templateUrl: './upload-image-dialog.component.html',
                styleUrls: ['./upload-image-dialog.component.scss']
            }]
    }], null, { editor: [{
            type: Input
        }] }); })();

const _c0 = ["additionalTextupload"];
const _c1 = ["additionalTextkendoeditor"];
const _c2 = ["froalaForm"];
class EditorLibraryComponent {
    constructor(apiService, toastr, store) {
        this.apiService = apiService;
        this.toastr = toastr;
        this.store = store;
        this.observableSubscription$ = new Subject();
        this.sendApiStatus = new EventEmitter();
        this.additionalText = '';
    }
    ngAfterViewInit() {
        this.froalaForm.form.valueChanges.pipe(takeUntil(this.observableSubscription$), map$1(() => this.froalaForm.dirty)).subscribe((dirty) => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true,
                    formStatus: { formName: 'froalaForm', dirtyStatus: true }
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
        this.getData();
    }
    ngOnInit() {
        this.events
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(() => {
            this.postData();
        });
    }
    additionalTextimageuploaddialog() {
        this.additionalTextupload.open();
    }
    additionalTexteditorValueChange(value) {
        this.additionalText = value;
    }
    postData() {
        const payload = {
            "additionalText": this.additionalText,
            "infoName": this.infoName,
            "infoType": this.infoType,
            "isDel": 0
        };
        this.apiService.postEditorData(this.primaryData.visatype, this.primaryData.caseId, payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.status && response.status === 200) {
                this.toastr.success(response.message, 'Success');
                this.sendApiStatus.emit(response.message);
                this.getData();
            }
        });
    }
    getData() {
        this.apiService.getData(this.primaryData.visatype, this.primaryData.caseId, this.infoType)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a;
            if (response && response.status) {
                if (response.data['infoType'] === this.infoType) {
                    this.additionalText = (_a = response.data) === null || _a === void 0 ? void 0 : _a.additionalText;
                    this.froalaForm.resetForm(response.data);
                }
            }
        });
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
EditorLibraryComponent.ɵfac = function EditorLibraryComponent_Factory(t) { return new (t || EditorLibraryComponent)(i0.ɵɵdirectiveInject(APIEditor), i0.ɵɵdirectiveInject(i2$1.ToastrService), i0.ɵɵdirectiveInject(i3$1.Store)); };
EditorLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: EditorLibraryComponent, selectors: [["lib-editor-library"]], viewQuery: function EditorLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
        i0.ɵɵviewQuery(_c1, 1);
        i0.ɵɵviewQuery(_c2, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.additionalTextupload = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.additionalTextkendoeditor = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.froalaForm = _t.first);
    } }, inputs: { primaryData: "primaryData", disabledControls: "disabledControls", infoName: "infoName", infoType: "infoType", events: "events" }, outputs: { additionalTextkendoeditor: "additionalTextkendoeditor", sendApiStatus: "sendApiStatus" }, decls: 60, vars: 5, consts: [["froalaForm", "ngForm"], [1, "mt-4", "preview-comp", 3, "innerHtml", "hidden"], [1, "mt-4", 3, "hidden"], ["name", "additionalText", 2, "height", "400px", 3, "value", "valueChange"], ["additionalTextkendoeditor", ""], ["kendoEditorBoldButton", ""], ["kendoEditorItalicButton", ""], ["kendoEditorUnderlineButton", ""], ["kendoEditorStrikethroughButton", ""], ["kendoEditorSubscriptButton", ""], ["kendoEditorSuperscriptButton", ""], ["kendoEditorAlignLeftButton", ""], ["kendoEditorAlignCenterButton", ""], ["kendoEditorAlignRightButton", ""], ["kendoEditorAlignJustifyButton", ""], ["kendoEditorFormat", ""], ["kendoEditorFontSize", ""], ["kendoEditorFontFamily", ""], ["kendoEditorForeColor", ""], ["kendoEditorBackColor", "", "view", "gradient"], ["kendoEditorInsertUnorderedListButton", ""], ["kendoEditorInsertOrderedListButton", ""], ["kendoEditorIndentButton", ""], ["kendoEditorOutdentButton", ""], ["kendoEditorBlockquoteButton", ""], ["kendoEditorSelectAllButton", ""], ["kendoEditorUndoButton", ""], ["kendoEditorRedoButton", ""], ["kendoEditorCreateLinkButton", ""], ["kendoEditorUnlinkButton", ""], ["kendoEditorInsertFileButton", ""], ["kendoEditorViewSourceButton", ""], ["kendoEditorCleanFormattingButton", ""], ["kendoEditorAddColumnBeforeButton", ""], ["kendoEditorAddColumnAfterButton", ""], ["kendoEditorAddRowBeforeButton", ""], ["kendoEditorAddRowAfterButton", ""], ["kendoEditorDeleteColumnButton", ""], ["kendoEditorDeleteRowButton", ""], ["kendoEditorDeleteTableButton", ""], ["kendoEditorMergeCellsButton", ""], ["kendoEditorSplitCellButton", ""], ["kendoEditorPrintButton", ""], ["kendoEditorInsertImageButton", ""], ["title", "Upload\u2019s Image at cursor point", "text", "Upload Image", 3, "click"], [3, "editor"], ["additionalTextupload", ""]], template: function EditorLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", null, 0);
        i0.ɵɵelement(2, "div", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "kendo-editor", 3, 4);
        i0.ɵɵlistener("valueChange", function EditorLibraryComponent_Template_kendo_editor_valueChange_4_listener($event) { return ctx.additionalText = $event; })("valueChange", function EditorLibraryComponent_Template_kendo_editor_valueChange_4_listener($event) { return ctx.additionalTexteditorValueChange($event); });
        i0.ɵɵelementStart(6, "kendo-toolbar");
        i0.ɵɵelementStart(7, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(8, "kendo-toolbar-button", 5);
        i0.ɵɵelement(9, "kendo-toolbar-button", 6);
        i0.ɵɵelement(10, "kendo-toolbar-button", 7);
        i0.ɵɵelement(11, "kendo-toolbar-button", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(13, "kendo-toolbar-button", 9);
        i0.ɵɵelement(14, "kendo-toolbar-button", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(16, "kendo-toolbar-button", 11);
        i0.ɵɵelement(17, "kendo-toolbar-button", 12);
        i0.ɵɵelement(18, "kendo-toolbar-button", 13);
        i0.ɵɵelement(19, "kendo-toolbar-button", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(20, "kendo-toolbar-dropdownlist", 15);
        i0.ɵɵelement(21, "kendo-toolbar-dropdownlist", 16);
        i0.ɵɵelement(22, "kendo-toolbar-dropdownlist", 17);
        i0.ɵɵelement(23, "kendo-toolbar-colorpicker", 18);
        i0.ɵɵelement(24, "kendo-toolbar-colorpicker", 19);
        i0.ɵɵelementStart(25, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(26, "kendo-toolbar-button", 20);
        i0.ɵɵelement(27, "kendo-toolbar-button", 21);
        i0.ɵɵelement(28, "kendo-toolbar-button", 22);
        i0.ɵɵelement(29, "kendo-toolbar-button", 23);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(30, "kendo-toolbar-button", 24);
        i0.ɵɵelement(31, "kendo-toolbar-button", 25);
        i0.ɵɵelementStart(32, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(33, "kendo-toolbar-button", 26);
        i0.ɵɵelement(34, "kendo-toolbar-button", 27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(36, "kendo-toolbar-button", 28);
        i0.ɵɵelement(37, "kendo-toolbar-button", 29);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(38, "kendo-toolbar-button", 30);
        i0.ɵɵelement(39, "kendo-toolbar-button", 31);
        i0.ɵɵelement(40, "kendo-toolbar-button", 32);
        i0.ɵɵelement(41, "kendo-editor-insert-table-button");
        i0.ɵɵelementStart(42, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(43, "kendo-toolbar-button", 33);
        i0.ɵɵelement(44, "kendo-toolbar-button", 34);
        i0.ɵɵelement(45, "kendo-toolbar-button", 35);
        i0.ɵɵelement(46, "kendo-toolbar-button", 36);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(47, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(48, "kendo-toolbar-button", 37);
        i0.ɵɵelement(49, "kendo-toolbar-button", 38);
        i0.ɵɵelement(50, "kendo-toolbar-button", 39);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(51, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(52, "kendo-toolbar-button", 40);
        i0.ɵɵelement(53, "kendo-toolbar-button", 41);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(54, "kendo-toolbar-button", 42);
        i0.ɵɵelementStart(55, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(56, "kendo-toolbar-button", 43);
        i0.ɵɵelementStart(57, "kendo-toolbar-button", 44);
        i0.ɵɵlistener("click", function EditorLibraryComponent_Template_kendo_toolbar_button_click_57_listener() { return ctx.additionalTextimageuploaddialog(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(58, "app-upload-image-dialog", 45, 46);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(5);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("innerHtml", ctx.additionalText, i0.ɵɵsanitizeHtml)("hidden", !ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("hidden", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("value", ctx.additionalText);
        i0.ɵɵadvance(54);
        i0.ɵɵproperty("editor", _r1);
    } }, directives: [i3.ɵangular_packages_forms_forms_ba, i3.NgControlStatusGroup, i3.NgForm, i5$1.EditorComponent, i6$1.ToolBarComponent, i6$1.ToolBarButtonGroupComponent, i6$1.ToolBarButtonComponent, i5$1.EditorBoldButtonDirective, i5$1.EditorItalicButtonDirective, i5$1.EditorUnderlineButtonDirective, i5$1.EditorStrikethroughButtonDirective, i5$1.EditorSubscriptButtonDirective, i5$1.EditorSuperscriptButtonDirective, i5$1.EditorAlignLeftButtonDirective, i5$1.EditorAlignCenterButtonDirective, i5$1.EditorAlignRightButtonDirective, i5$1.EditorAlignJustifyButtonDirective, i5$1.EditorFormatComponent, i5$1.EditorFontSizeComponent, i5$1.EditorFontFamilyComponent, i5$1.EditorColorPickerComponent, i5$1.EditorForeColorDirective, i5$1.EditorBackColorDirective, i5$1.EditorInsertUnorderedListButtonDirective, i5$1.EditorInsertOrderedListButtonDirective, i5$1.EditorIndentButtonDirective, i5$1.EditorOutdentButtonDirective, i5$1.EditorBlockquoteDirective, i5$1.EditorSelectAllButtonDirective, i5$1.EditorUndoButtonDirective, i5$1.EditorRedoButtonDirective, i5$1.EditorCreateLinkButtonDirective, i5$1.EditorUnlinkButtonDirective, i5$1.EditorInsertFileButtonDirective, i5$1.EditorViewSourceButtonDirective, i5$1.EditorCleanFormattingButtonDirective, i5$1.EditorInsertTableButtonComponent, i5$1.EditorAddColumnBeforeButtonDirective, i5$1.EditorAddColumnAfterButtonDirective, i5$1.EditorAddRowBeforeButtonDirective, i5$1.EditorAddRowAfterButtonDirective, i5$1.EditorDeleteColumnButtonDirective, i5$1.EditorDeleteRowButtonDirective, i5$1.EditorDeleteTableButtonDirective, i5$1.EditorMergeCellsButtonDirective, i5$1.EditorSplitCellButtonDirective, i5$1.EditorPrintDirective, i5$1.EditorInsertImageButtonDirective, UploadImageDialogComponent], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditorLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-editor-library',
                templateUrl: './editor-library.component.html',
                styleUrls: []
            }]
    }], function () { return [{ type: APIEditor }, { type: i2$1.ToastrService }, { type: i3$1.Store }]; }, { additionalTextupload: [{
            type: ViewChild,
            args: ["additionalTextupload"]
        }], additionalTextkendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["additionalTextkendoeditor"]
        }], froalaForm: [{
            type: ViewChild,
            args: ['froalaForm', { static: true }]
        }], primaryData: [{
            type: Input
        }], disabledControls: [{
            type: Input
        }], infoName: [{
            type: Input
        }], infoType: [{
            type: Input
        }], events: [{
            type: Input
        }], sendApiStatus: [{
            type: Output
        }] }); })();

class EditorLibraryModule {
}
EditorLibraryModule.ɵfac = function EditorLibraryModule_Factory(t) { return new (t || EditorLibraryModule)(); };
EditorLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: EditorLibraryModule });
EditorLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: UploadImageDialogComponent,
            multi: true,
        },
    ], imports: [[
            FormsModule,
            CommonModule,
            EditorModule,
            DialogsModule,
            InputsModule,
            UploadModule
            // FroalaEditorModule.forRoot(),
            // FroalaViewModule.forRoot(),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(EditorLibraryModule, { declarations: [EditorLibraryComponent, UploadImageDialogComponent, UploadImageComponent], imports: [FormsModule,
        CommonModule,
        EditorModule,
        DialogsModule,
        InputsModule,
        UploadModule
        // FroalaEditorModule.forRoot(),
        // FroalaViewModule.forRoot(),
    ], exports: [EditorLibraryComponent, UploadImageDialogComponent, UploadImageComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditorLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [EditorLibraryComponent, UploadImageDialogComponent, UploadImageComponent],
                imports: [
                    FormsModule,
                    CommonModule,
                    EditorModule,
                    DialogsModule,
                    InputsModule,
                    UploadModule
                    // FroalaEditorModule.forRoot(),
                    // FroalaViewModule.forRoot(),
                ],
                providers: [
                    {
                        provide: HTTP_INTERCEPTORS,
                        useClass: UploadImageDialogComponent,
                        multi: true,
                    },
                ],
                exports: [EditorLibraryComponent, UploadImageDialogComponent, UploadImageComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of editor-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EditorLibraryComponent, EditorLibraryModule, UploadImageComponent, UploadImageDialogComponent };
//# sourceMappingURL=editor-library.js.map
